import { BindAll } from 'lodash-decorators'
import { MyAccountController } from './account'
import { MyStudyController } from './study'
import { MyCourseController } from './course'
import { MyClassroomController } from './classroom'
import { MySettingsController } from './settings'

@BindAll()
export class ControllerV2My {
  /**
   * 我的教室
   */
  Classroom = new MyClassroomController()

  /**
   * 我的课程
   */
  Course = new MyCourseController()

  /**
   * 我的学习
   */
  Study = new MyStudyController()

  /**
   * 我的账户
   */
  Account = new MyAccountController()

  /**
   * 账号设置
   */
  Settings = new MySettingsController()
}
